var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3513_16214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33325C6.67446 1.33501 5.40371 1.86236 4.46641 2.79966C3.52911 3.73696 3.00176 5.00771 3 6.33325C3 9.92284 7.65833 14.4187 7.85625 14.6083C7.89475 14.6457 7.94632 14.6666 8 14.6666C8.05368 14.6666 8.10525 14.6457 8.14375 14.6083C8.34167 14.4187 13 9.92284 13 6.33325C12.9982 5.00771 12.4709 3.73696 11.5336 2.79966C10.5963 1.86236 9.32554 1.33501 8 1.33325V1.33325ZM8 8.62492C7.54675 8.62492 7.10368 8.49051 6.72682 8.2387C6.34996 7.98689 6.05623 7.62898 5.88278 7.21024C5.70933 6.79149 5.66394 6.33071 5.75237 5.88617C5.84079 5.44163 6.05905 5.03329 6.37955 4.7128C6.70004 4.3923 7.10838 4.17404 7.55292 4.08562C7.99746 3.99719 8.45824 4.04258 8.87698 4.21603C9.29573 4.38948 9.65364 4.68321 9.90545 5.06007C10.1573 5.43693 10.2917 5.88 10.2917 6.33325C10.2913 6.94093 10.0497 7.52361 9.62005 7.9533C9.19036 8.38299 8.60768 8.62455 8 8.62492Z",
    fill: "#918F93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3513_16214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(1.33331 1.33325)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.8cec96e6bcd7d32f6fb8126b824e036a.svg";
export { ForwardRef as ReactComponent };